import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const getOrganizationFavouriteLocations = async ({
  accessToken,
  organizationId,
}: {
  accessToken: string;
  organizationId?: string;
}) => {
  try {
    if (accessToken) {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/admin/organization-favourite-locations/${organizationId}`,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      return data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("error", error);
  }
};

const addNewOrganizationFavouriteLocation = async ({
  accessToken,
  organizationId,
  formFields,
}: {
  accessToken: string;
  organizationId?: string;
  formFields: {
    displayName: string;
    latitude: number;
    longitude: number;
    address: string;
  };
}) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/admin/organization-favourite-locations/${organizationId}`,
      formFields,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    return data;
  } catch (error: any) {
    console.log("error submitting new organization favourite location", error);
  }
};

const deleteOrganizationFavouriteLocation = async ({
  accessToken,
  organizationFavouriteLocationId,
}: {
  accessToken: string;
  organizationFavouriteLocationId: string;
}) => {
  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/admin/organization-favourite-locations/${organizationFavouriteLocationId}`,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    return data;
  } catch (error: any) {
    console.log("error submitting new organization favourite location", error);
  }
};

const useOrganizationFavouriteLocations = ({
  accessToken,
  organizationId,
}: {
  accessToken: string;
  organizationId?: string;
}) => {
  return useQuery({
    queryKey: ["organization-favourite-locations", organizationId],
    queryFn: () =>
      getOrganizationFavouriteLocations({
        accessToken,
        organizationId,
      }),
    keepPreviousData: true,
  });
};

export {
  getOrganizationFavouriteLocations,
  useOrganizationFavouriteLocations,
  addNewOrganizationFavouriteLocation,
  deleteOrganizationFavouriteLocation,
};
